import { createContext, useState, useContext, useEffect } from "react";
import useEgresado from "../hooks/HookEgresado";


const EgresadoContext = createContext({
    alumno: null,
    setAlumno: () => { },
    getProfile: () => { },
    loading: true,
});

export const EgresadoProvider = ({ children }) => {
    const [alumno, setAlumno] = useState(null);
    const [showWelcomeCard,  setShowWelcomeCard] = useState(null);
    const { loading, getProfileEgresado } = useEgresado();

    const getProfile = async () => {
        const response = await getProfileEgresado();
        setAlumno(response?.data);
    }; 

    useEffect(() => {
        getProfile();
    }, []);


    return (
        <EgresadoContext.Provider value={{
            alumno,
            loading,
            getProfile,
            showWelcomeCard,
            setShowWelcomeCard
        }}>
            {children}
        </EgresadoContext.Provider>
    )
}

export const useEgresadoContext = () => useContext(EgresadoContext);